import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = { isSaved: null, processing: false };

const checkSavedCourseSlice = createSlice({
  name: "checkSavedCourse",
  initialState,
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
      state.isSaved = false;
    },
    markSaved(state) {
      state.processing = false;
      /* TODO: reducer for success*/
      state.isSaved = true;
    },
    markUnsaved(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
      state.isSaved = false;
    },
  },
});

const { name, actions, reducer } = checkSavedCourseSlice;
const checkSavedCourseAction = createAction(name);

export {
  checkSavedCourseAction,
  actions as checkSavedCourseActions,
  reducer as checkSavedCourseReducer,
};
